import {hotelStates} from './../modules/hotels/hotels-routes';

export default function AuthenticationConfig(
    $rootScope,
    $state,
    $location,
    $window,
    authService,
    userService,
    sessionService,
    loginFactory,
    locationService,
    ktAlert
) {
    'ngInject';

        const defaultState = 'main.flights.roundtrip';

        function isOnLoginPage() {
            return $window.location.hash.indexOf('login') > 0;
        }

        function changeState(event, state) {
            event.preventDefault();
            $state.go(state);
        }

        $rootScope.$on('$stateChangeStart', (event, toState) => {
            onStateChangeStart(event, toState);
            ktAlert.clear();
        });

        function onStateChangeStart(event, toState) {
            const isLoggedIn = authService.isLoggedIn() || authService.isAuthorizedAgentUrl(toState);

            if (!isLoggedIn && !isOnLoginPage()) {
                locationService.saveHash($window.location.hash);
            }

            const adminURL = $location.search().ReturnUrl;

            const isTripDetailsPage = loginFactory.isTripDetailsHashExeption($location.$$url) // eslint-disable-line
                && _.startsWith(toState.name, 'main.trip');

            const isRulesPage = ['main.flights.results.rules', 'main.cars.rules'].includes(toState.name);
            const isHotelDetailsPage = toState.name === hotelStates.MAIN_VIEW;

            const isReadOnlyMode = (!isLoggedIn && (isTripDetailsPage || isHotelDetailsPage || isRulesPage));

            $rootScope.readOnlyMode = isReadOnlyMode;
            sessionService.setSessionItem('readOnlyMode', isReadOnlyMode);
            $rootScope.date = new Date();
            const state = getState();
            if (state) {
                return changeState(event, state);
            }

            if (isReadOnlyMode) {
                sessionService.setSessionItem('readOnlyMode', true);
            }

            function getState() {

                /**
                 * If user is not authenticated and tries to change page and this page is not the login page, and
                 * not a trip details page and not hotel(because authorization logic will be on details page)
                 * we must redirect him to the login page.
                 */
                const conditionLogin = !isTripDetailsPage
                        && !isHotelDetailsPage
                        && !isRulesPage
                        && toState.name.indexOf('login') === -1;

                if (!isLoggedIn && conditionLogin) {
                    return 'login';
                }

                const conditionDefault = (function() {

                    /**
                     * If user authenticated and tries to navigate to the login page, we must redirect him to
                     * the main page. But if the ReturnUrl parameter exist we have to pass user to login page
                     * (he will be redirected to admin panel)
                     */
                    return (toState.name.indexOf('login') !== -1 && !adminURL)

                        /**
                         * If user authenticated and tries to change page and he don't have permissions for
                         * this page, we must redirect him to the main page.
                         */
                        || (toState.permission && !userService.checkPermissions(toState.permission))

                        /**
                         * If user is authenticated and tries to enter the checkout state without booker or
                         * holder role
                         */
                        || (toState.name === 'main.trip.checkout' && !userService.isCheckoutAllowed());
                }());

                if (isLoggedIn && conditionDefault) {
                    return defaultState;
                }

                /**
                 * If user authenticated and tries to change page and he don't have access for this page,
                 * we must redirect him to the main page.
                 */
                if (isLoggedIn && !authService.hasPermission(toState)) {
                    if (authService.dontHaveSearchPermission()) {
                        return 'main.trip.list';
                    }
                    return authService.permissionRedirectPage(toState);

                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/app/configs/authConfig.js